module.exports = __webpack_public_path__ + "media/images/okra-offers/Rewards-Earn-01-fe135105319adac76511089d0aee9024.jpg";